import actions from '@/store/modules/merchant-config/actions';
import getters from '@/store/modules/merchant-config/getters';
import mutations from '@/store/modules/merchant-config/mutations';
import state from '@/store/modules/merchant-config/state';

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
